import { FC } from 'react';
import BarChartBlock from './components/BarChartBlock/BarChartBlock';
import ColumnChartBlock from './components/ColumnChartBlock/ColumnChartBlock';
import DocLinkBlock from './components/DocLinkBlock/DocLinkBlock';
import DownloadBlock from './components/DownloadBlock/DownloadBlock';
import LineChartBlock from './components/LineChartBlock/LineChartBlock';
import PieChartBlock from './components/PieChartBlock/PieChartBlock';
import ProductCardsBlock from './components/ProductCardsBlock/ProductCardsBlock';
import { VizBlock, VizBlockComponentProps } from './viz.types';

export const vizRegistry: Record<VizBlock['kind'], FC<VizBlockComponentProps>> = {
  'line-chart': LineChartBlock as FC<VizBlockComponentProps>,
  'pie-chart': PieChartBlock as FC<VizBlockComponentProps>,
  'bar-chart': BarChartBlock as FC<VizBlockComponentProps>,
  'column-chart': ColumnChartBlock as FC<VizBlockComponentProps>,
  download: DownloadBlock as FC<VizBlockComponentProps>,
  'doc-link': DocLinkBlock as FC<VizBlockComponentProps>,
  'product-cards': ProductCardsBlock as FC<VizBlockComponentProps>,
};
